export default __webpack_public_path__ + "static/sanblas-4706b8d6ebe0c7a99e1a6cb736382f9b.jpg";